var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"restore-questionnaire-page"},[_c('restore-questionnaire-modal',{attrs:{"patient-email":_vm.email,"error":_vm.error},on:{"continue":_vm.onContinue,"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }